import {useAppSelector} from '@/hooks';
import type {TextStylesObject} from '@PosterWhiteboard/classes/text-styles.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TranscriptItemObject} from '@PosterWhiteboard/items/transcript-item/transcript-item.types';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';

export function useGetKeyFromSubtitleTextStylesForTranscriptItem<T extends keyof TextStylesObject>(key: T, isActiveWord = false): TextStylesObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const itemObject = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];
    if (!itemObject) {
      return undefined;
    }

    if (itemObject.gitype !== ITEM_TYPE.TRANSCRIPT) {
      throw new Error(`Item isn't a transcript item`);
    }

    const transcriptItemObject = itemObject as TranscriptItemObject;
    const anySubtitleObject = Object.values(transcriptItemObject.subtitlesHashmap)[0];

    if (isActiveWord) {
      if (anySubtitleObject.activeWordTextStyles[key] !== undefined) {
        return anySubtitleObject.activeWordTextStyles[key];
      }
    } else {
      if (anySubtitleObject.sentenceTextStyles[key] !== undefined) {
        return anySubtitleObject.sentenceTextStyles[key];
      }
    }

    return undefined;
  });
}
